/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 09.01.13, 08:43
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


import { IBasicGGSTextField } from "../IBasicGGSTextField";
import { GGSTextFieldSignal } from "./GGSTextFieldSignal";

import FocusEvent = createjs.FocusEvent;

export class FocusInSignal extends GGSTextFieldSignal {
    constructor() {
        super();
        this.mappedEventType = FocusEvent.FOCUS_IN;
    }

    public dispatchTyped(basicTextField: IBasicGGSTextField): void {
        super.dispatch(basicTextField);
    }
}
